// import React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

export default function DemyOut() {
  const [pubData] = useOutletContext();
  return (
    <div>
      <Outlet context={[pubData]}/>
    </div>
  )
}
